
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { envVariables } from "../../../../helpers";
import { useDescuentosStore } from "../../../../store";
import { TooltipAndIcon } from "../../components/TooltipAndIcon";
import { startEliminarDescuento } from "../../../../services";
import { useQueryClient } from "@tanstack/react-query";

import dayjs from "dayjs";
import Swal from "sweetalert2";
const paginado = Number( envVariables.REACT_APP_PAGINADO);




export const TablaDetalleDescuento = ({ data, page, chagePage }) => {


    const queryClient = useQueryClient();
    const { totalDescuento } = useDescuentosStore();


    const handleEliminarInfo = (id) => {
        Swal.fire({
            title: `Eliminar Descuento`,
            text: `¿Esta seguro de eliminar este descuento?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, Eliminar` 
        }).then( async( result ) => {
            if(result.value){
                const resp = await startEliminarDescuento(id);
                if( resp ){
                    queryClient.invalidateQueries('descuento-tipo');
                }
            }
        });
    }

    


    return (
        
        <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
            <TableContainer sx={{ maxWidth:'100%' }}>
                <Table sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{width:'20%'}}>FECHA</TableCell>
                            <TableCell sx={{width:'20%'}}>CANTIDAD</TableCell>
                            <TableCell sx={{width:'30%'}}>OBSERVACIÓN</TableCell>
                            <TableCell sx={{width:'20%'}}>TIPO</TableCell>
                            <TableCell sx={{width:'10%'}}>ACCION</TableCell>

                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {(data.map( item => (
                            <TableRow key={item.id}>
                                <TableCell>{dayjs(item.fecha).format('DD/MMM/YY HH:mm').toUpperCase()}</TableCell>
                                <TableCell>{ item.cantidad }</TableCell>
                                <TableCell>{ item.observacion }</TableCell>
                                <TableCell>{ item.descuento }</TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Eliminar Registro'
                                        icono='eliminar'
                                        onClick={ () => handleEliminarInfo(item.id) }
                                        color='red'
                                    />
                                </TableCell>
                            </TableRow>
                        )))}
                    </TableBody>
                </Table>

                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalDescuento / paginado)} disabled={Math.ceil(totalDescuento / paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            </TableContainer>
        </Paper>
    )
}
